import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStoreShop = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 21V30H28V21",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 10L9.00001 15C8.9985 15.6744 9.22485 16.3295 9.64235 16.8591C10.0598 17.3886 10.644 17.7617 11.3001 17.9176C11.9562 18.0735 12.6457 18.0033 13.2569 17.7182C13.868 17.4331 14.3649 16.9499 14.667 16.347C14.9135 16.8435 15.2937 17.2613 15.7648 17.5534C16.2359 17.8455 16.7792 18.0003 17.3335 18.0003C17.8878 18.0003 18.4311 17.8455 18.9022 17.5534C19.3733 17.2613 19.7535 16.8435 20 16.347C20.2465 16.8435 20.6267 17.2613 21.0978 17.5534C21.5689 17.8455 22.1122 18.0003 22.6665 18.0003C23.2208 18.0003 23.7641 17.8455 24.2352 17.5534C24.7063 17.2613 25.0865 16.8435 25.333 16.347C25.6351 16.9499 26.132 17.4331 26.7432 17.7182C27.3543 18.0033 28.0438 18.0735 28.6999 17.9176C29.356 17.7617 29.9402 17.3886 30.3577 16.8591C30.7752 16.3295 31.0015 15.6744 31 15L28 10H12Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 30V24H22V30",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgStoreShop);
export default ForwardRef;
